import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'
import { dateToPlainFormat } from '@/utils'

export interface ProcessInspectionCollection {
  collectionId: number
  collectionNo: string
  collectionStatus: SystemCode
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  appendixCode: SystemCode
  dueDate: string
  overdueDays: number
  holdingBranchCode: SystemCode
  forwardingBranchCode: SystemCode
  shelfType: SystemCode
  handlingType: SystemCode
  lendTotal: number
  userIdReserved: string
  memoFlag: boolean
  collectionFlag: CollectionFlag
}

export const defaultProcessInspectionCollection = (): ProcessInspectionCollection => ({
  collectionId: 0,
  collectionNo: '',
  collectionStatus: defaultSystemCode(),
  bibliographyClass: BibliographyClass.Real,
  prefix: Prefix.Real,
  bibliographyId: 0,
  searchType: defaultSystemCode(),
  displayTitle: '',
  displayAuthor: '',
  appendixCode: defaultSystemCode(),
  dueDate: '',
  overdueDays: 0,
  holdingBranchCode: defaultSystemCode(),
  forwardingBranchCode: defaultSystemCode(),
  shelfType: defaultSystemCode(),
  handlingType: defaultSystemCode(),
  lendTotal: 0,
  userIdReserved: '',
  memoFlag: false,
  collectionFlag: CollectionFlag.NotCollection
})

export function ProcessInspectionCollectionFromJSON(
  json: any
): ProcessInspectionCollection {
  return {
    collectionId: exists(json, 'collection_id') ? json.collection_id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    collectionStatus: exists(json, 'collection_status')
      ? SystemCodeFromJSON(json.collection_status)
      : defaultSystemCode(),
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    dueDate: exists(json, 'due_date') ? dateToPlainFormat(json.due_date) : '',
    overdueDays: exists(json, 'overdue_days') ? json.overdue_days : 0,
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    forwardingBranchCode: exists(json, 'forwarding_branch_code')
      ? SystemCodeFromJSON(json.forwarding_branch_code)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    lendTotal: exists(json, 'lend_total') ? json.lend_total : 0,
    userIdReserved: exists(json, 'user_id_reserved')
      ? json.user_id_reserved
      : '',
    memoFlag: exists(json, 'memo_flag') ? json.memo_flag : false,
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection
  }
}
